import { Component, computed, inject } from "@angular/core";
import { StockTypeForm } from "../../models/stock-type-form.model";
import { SectionComponent } from "@shared-core/components/section/section.component";
import { TextInputComponent } from "@kernel/form/modules/inputs/simple-inputs/components/text-input/text-input.component";
import { ReactiveFormsModule } from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";
import { UploadFileComponent } from "@kernel/form/modules/file/components/upload-file/upload-file.component";
import { FileUploadDesignComponent } from "@shared-core/components/file-upload-design/file-upload-design.component";
import { DetailsStatusComponent } from "@shared-core/components/details-status/details-status.component";
import { ActivityLogComponent } from "@shared-core/components/activity-log/activity-log.component";
import { StockTypeApiService } from "../../services/stock-type-api.service";
import { untilDestroyed } from "../../../../../../shared-core/helpers/until-destroy.helper";
import { TextAreaComponent } from "@kernel/form/modules/inputs/simple-inputs/components/text-area/text-area.component";
import { LabelAsteriskDirective } from "@kernel/form/modules/tools/form-stepper/directives/label-asterisk.directive";

@Component({
  selector: "app-stock-type-form",
  imports: [
    SectionComponent,
    UploadFileComponent,
    FileUploadDesignComponent,
    TextInputComponent,
    ReactiveFormsModule,
    TranslatePipe,
    DetailsStatusComponent,
    ActivityLogComponent,
    TextAreaComponent,
    LabelAsteriskDirective,
  ],
  templateUrl: "./stock-type-form.component.html",
  styleUrl: "./stock-type-form.component.scss",
})
export class StockTypeFormComponent {
  /**
   * Service for handling API calls related to stock types.
   */
  private stockTypeService = inject(StockTypeApiService);
  /**
   * Injected form model managing the form state and validation logic.
   */
  formModel = inject(StockTypeForm);

  code = this.formModel.controlValueAsSignal("code");

  /**
   * The current stock type entity being edited or viewed.
   */
  stockType = computed(() => this.formModel.entity());
  /**
   * Utility for handling subscription cleanup on component destruction.
   */
  takeUntilDestroy = untilDestroyed();

  /**
   * Handles the status change of a stock type.
   * Calls the appropriate API method based on the requested action.
   *
   * @param confirm - The action to perform: "enable", "disable", or null to cancel
   */
  onConfirm(confirm: "enable" | "disable" | null) {
    if (!confirm) return;
    let _obs = this.stockTypeService.enableStockType(this.stockType()?.id!);
    if (confirm === "disable") {
      _obs = this.stockTypeService.disableStockType(this.stockType()?.id!);
    }
    _obs.pipe(this.takeUntilDestroy()).subscribe();
  }
}
